/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyercodelabel3Inputs */

const en_checkinflyercodelabel3 = /** @type {(inputs: Checkinflyercodelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in code`)
};

const de_checkinflyercodelabel3 = /** @type {(inputs: Checkinflyercodelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in-Code`)
};

/**
* | output |
* | --- |
* | "Check-in code" |
*
* @param {Checkinflyercodelabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyercodelabel3 = /** @type {((inputs?: Checkinflyercodelabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyercodelabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyercodelabel3(inputs)
	return de_checkinflyercodelabel3(inputs)
});
export { checkinflyercodelabel3 as "checkinFlyerCodeLabel" }